<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav/>
            </div>
        </el-header>
        <el-main class="about">
            <div class="contBox" id="jobContBox" ref="jobContBox">
                <h3>加入我们<span>HR邮箱：hr@harqom.com</span></h3>
                <el-divider class="fg"></el-divider>
                <el-collapse accordion class="jobList">
                    <el-scrollbar style="height: 100%">
                        <el-collapse-item v-for="(job,index) in tableData" :key="index">
                            <template slot="title">
                                <p v-for="(type,index) in job.type" :key="index" class="jobType"> {{ type }}</p>
                            </template>
                            <div>
                                <h4> 岗位职责 </h4>
                                <ul>
                                    <li v-for="(jd,index) in job.jd" :key="index"> {{ jd }}</li>
                                </ul>
                            </div>
                            <div>
                                <h4> 任职资格 </h4>
                                <ul>
                                    <li v-for="(jobZ,index) in job.jobZ" :key="index"> {{ jobZ }} </li>
                                </ul>
                            </div>
                        </el-collapse-item>
                    </el-scrollbar>

                </el-collapse>
            </div>
        </el-main>
        <el-footer class="footer">
            <hq-footer/>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";

    export default {
        name: "JoinHQ",
        data() {
            return {
                tableData: require('../assets/JSON/JobData.json')
            }
        },
        methods:{

        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer,
        }
    }
</script>

<style>

    .contBox .jobList{
        height:  80%;
    }
    .jobList  .el-scrollbar__wrap{
        overflow-x: hidden;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap{
        color:#ffffff;
        background: none;
        font-family: AlibabaPuhuiTiR;
        font-size: 1rem;
    }
    .el-collapse-item__content{
        color: #ffffff;
        text-align: left;
        font-family: AlibabaPuhuiTiR;
        font-size: 0.8rem;
        padding-left: 2rem;
    }
</style>
<style scoped>
    #jobContBox{
        height:  calc(100vw - 77rem);
    }
    .footer{
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .about{
        background: url("../assets/images/bottom.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .about h3{
        font-family: AlibabaPuHuiTi-Heavy;
        font-size: 3.35rem;
        color: #ffffff;
        margin: 1rem 0;
        text-align: left;
    }
    .about h3 span{
        font-weight: normal;
        font-family: AlibabaPuHuiTi;
        font-size: 18px;
        margin-left: 10px;
    }

    .contBox h4{
        font-family: AlibabaPuHuiTi-Light;
        font-size: 1.6rem;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }
    .jobType{
        width: 10rem;
        float: left;
        text-align: left;
        margin-right: 5rem;
    }
    .jobType:first-child{
        width: 30rem;
    }
    .jobType:last-child{
        margin-right: 0;
    }
</style>